import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import i18next from 'i18next';
import Row from 'react-bootstrap/Row';

import Background from '../../resources/assets/hero-home-oct-2020.jpeg';
import CheckMark from '../../lib/CheckMark';
import InputBox from '../../lib/InputBox';
import Overlay from '../../lib/Overlay';
import { isValidPassword, isLongEnough, hasNumber, hasLetters, PASSWORD_MAX_LENGTH } from '../../lib/password';
import { redirect } from '../../lib/environment';

export default function ResetPasswordView(props) {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  return (<>
    <Container style={{
      minHeight: '710px',
      backgroundImage: `url(${Background})`,
      borderRadius: '3px' ,
      boxShadow: "0 0 8px 8px rgba(40, 44, 52, 0.7) inset"
      }}>
      <Row>
        <Col md={{ span: 7, offset: 1 }}>
          <InputBox style={{ height: '621px', width: '603px' }}>
            {props.state === 'success' ? renderSuccess() : renderForm()}
          </InputBox>
        </Col>
      </Row>
    </Container>
  </>);

  function renderForm() {
    return (<>
      {props.state === 'waiting' && <Overlay />}
      <Container style={{ marginLeft: '1em', marginRight: '1em' }}>
        <Row style={{ marginBottom: '10px' }}>{i18next.t('reset.title')}</Row>
        {displayRow(i18next.t('reset.minlength'), isLongEnough(newPassword))}
        {displayRow(i18next.t('reset.case'), hasLetters(newPassword))}
        {displayRow(i18next.t('reset.number'), hasNumber(newPassword))}
      </Container>
      <Form style={{ width: '100%', margin: '1em' }} onSubmit={event => {event.preventDefault(); props.onSubmit(oldPassword, newPassword)}}>
        <Form.Group controlId="oldPassword">
          <Form.Label>{i18next.t('change.oldPassword')}</Form.Label>
          <Form.Control name="oldPassword" type="password" placeholder={i18next.t('change.oldPassword')} value={oldPassword} maxLength={PASSWORD_MAX_LENGTH} onChange={event => setOldPassword(event.target.value)} autoFocus />
        </Form.Group>
        <Form.Group controlId="newPassword">
          <Form.Label>{i18next.t('change.newPassword')}</Form.Label>
          <Form.Control name="newPassword" type="password" placeholder={i18next.t('change.newPassword')} value={newPassword} maxLength={PASSWORD_MAX_LENGTH}  onChange={event => setNewPassword(event.target.value)} />
        </Form.Group>
        <Form.Group controlId="confirm">
          <Form.Label>{i18next.t('change.confirmPassword')}</Form.Label>
          <Form.Control name="confirmPassword" type="password" placeholder={i18next.t('change.confirmPassword')} value={confirmPassword} maxLength={PASSWORD_MAX_LENGTH}  onChange={event => setConfirmPassword(event.target.value)}  />
        </Form.Group>
        <Button name="submit-request" variant="primary" type="button" disabled={isDisabled()} onClick={() => props.onSubmit(oldPassword, newPassword)}>
          {i18next.t('change.changePassword')}
        </Button>
        <p id="message" style={{ marginTop: '0.5em' }}>{props.message}</p>
        {!isDisabled() && <input type='submit' hidden tabIndex='-1' />}
      </Form>
    </>);
  }

  function displayRow(label, passedCheck) {
    const colour = passedCheck ? 'rgba(181, 190, 92, 1)' : 'rgba(194, 158, 107, 0.6)';
    return <Row className="align-self-center"><CheckMark colour={colour} /> {label}</Row>
  }

  function isDisabled() {
    return !(isValidPassword(newPassword) && newPassword === confirmPassword && Boolean(oldPassword));
  }

  function renderSuccess() {
    return (<>
        <p id="message" style={{ margin: '1em' }}>{props.message}</p>
        <Button name="submit-redirect" variant="primary" type="button" disabled={isDisabled()} onClick={() => redirect()}>
          {i18next.t('reset.returnApplication')}
        </Button>
    </>);
  }
}
